import React from "react";

const Objectives = () => {
  return (
    <div className="px-6 lg:px-20 mb-20">
      <div className="lg:flex items-center justify-between lg:space-x-32 mb-14 max-lg:space-y-6">
        <div className="bg-themeGreen/20 px-10 py-16 rounded-md text-center">
          <h1 className="text-primaryBlack text-3xl font-semibold mb-3">
            Our Mission
          </h1>
          <span className="text-paragraph text-lg">
            To provide exceptional premium & emergency transportation, logistics
            and delivery service to businesses and individuals who makes use of
            the ZAP platform.
          </span>
        </div>
        <div className="bg-themeYellow/20 px-10 py-16 rounded-md text-center">
          <h1 className="text-primaryBlack text-3xl font-semibold mb-3">
            Our Vision
          </h1>
          <span className="text-paragraph text-lg">
            To be the leading last-mile delivery and logistics company in
            Africa, while providing premium and reliable transportation
            solutions for Individuals and businesses.
          </span>
        </div>
      </div>
      <div className="my-8">
        <h1 className="head-text">Our purpose</h1>
        <div className="text-center lg:max-w-[800px] text-lg mx-auto">
          <span>
            At ZAP, our purpose is to provide reliable and efficient delivery
            and logistics solutions that empowers businesses and individuals
            across Africa, enabling them to connect, grow, and thrive.
            <br />
            <br />
            To be a leading premium transportation provider in Africa,
            leveraging technology to connect people, businesses, and events with
            reliable, efficient, and safe transport solutions.
          </span>
        </div>
      </div>
    </div>
  );
};

export default Objectives;
